import { utils } from "near-api-js";

/**
 * Convert Near amount to yocto
 * @param amountInNear
 * @returns The amount in yocto
 */
export function convertNearToYocto(amountInNear: string): string {
    return utils.format.parseNearAmount(amountInNear) ?? "0";
}

/**
 * Convert yocto to Near amount
 * @param amountInYocto
 * @returns The amount in Near
 */
export function convertYoctoToNear(amountInYocto: string, fracDigits?: number | undefined): string {
    return utils.format.formatNearAmount(amountInYocto, fracDigits).replace(/,/g, "");
}
